/* Aussie Step — product page behaviour (converted from the design source).
   Reads window.AS_DATA, which the section renders from Shopify objects. */
(function(){
  function init(){

    var AS = window.AS_DATA || {};
    var TIERS = AS.tiers || {};
    var COLOURS = AS.colours || [];
    var state = {tier: AS.defaultTier || Object.keys(TIERS)[0], colour: (AS.colours && AS.colours[0] ? AS.colours[0].name : "")};
    /* Money formatting mirrors the section exactly: the section renders one
       sample amount through the money filter (plus the currency-prefix swap)
       and hands it over as AS.moneySample, e.g. "AU$1.00". Prefix, suffix and
       separators are read off that sample, so every JS-rendered price matches
       the Liquid-rendered ones. */
    var MONEY = (function(){
      var sample = (AS.moneySample || AS.moneyFormat || "$1.00").replace(/<[^>]*>/g, "");
      var m = sample.match(/^([^0-9]*)([0-9][0-9.,\s]*)([^0-9]*)$/);
      if(!m){ return {prefix:"$", suffix:"", dec:".", group:",", places:2}; }
      var num = m[2].trim();
      var lastDot = num.lastIndexOf("."), lastComma = num.lastIndexOf(",");
      var dec = ".", group = ",", places = 2;
      if(lastComma > lastDot){ dec = ","; group = "."; }
      var tail = num.slice(num.lastIndexOf(dec) + 1);
      if(num.indexOf(dec) === -1 || tail.length !== 2){ places = 0; }
      return {prefix:m[1], suffix:m[3], dec:dec, group:group, places:places};
    })();
    function pairWord(n){ return n === 1 ? "pair" : "pairs"; }
    function aud(n){
      var v = Number(n) || 0;
      var fixed = v.toFixed(MONEY.places);
      var parts = fixed.split(".");
      var whole = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, MONEY.group === "" ? "" : MONEY.group);
      var out = MONEY.places > 0 ? whole + MONEY.dec + parts[1] : whole;
      return MONEY.prefix + out + MONEY.suffix;
    }
    function variantId(){
      var map = AS.variants || {};
      return map[state.tier + "::" + state.colour] || map[state.tier + "::"] || AS.defaultVariantId;
    }
    function syncForm(){
      var idInput = document.getElementById("asVariantId");
      if(idInput){ idInput.value = variantId() || ""; }
    }
    function $(sel){ return document.querySelector(sel); }
    function $$(sel){ return Array.prototype.slice.call(document.querySelectorAll(sel)); }

    /* ---- toast ---- */
    var toast = $("#toast"), toastT;
    function say(msg){
      if(!toast) return;
      toast.textContent = msg;
      toast.classList.add("is-on");
      clearTimeout(toastT);
      toastT = setTimeout(function(){ toast.classList.remove("is-on"); }, 2600);
    }

    /* ---- single colour choice ---- */
    function colourSummary(){ return state.colour; }
    function renderColours(){
      $$("[data-colour-pick] .as-dot").forEach(function(btn){
        btn.setAttribute("aria-checked", btn.getAttribute("data-colour") === state.colour ? "true" : "false");
      });
    }

    /* ---- price-dependent UI ---- */
    function render(){
      var t = TIERS[state.tier];
      $$("[data-price-now]").forEach(function(el){ el.textContent = aud(t.price); });
      $$("[data-price-was]").forEach(function(el){
        el.textContent = aud(t.was);
        el.style.display = t.save ? "" : "none";
      });
      $$("[data-price-save]").forEach(function(el){
        el.textContent = "Save "+t.save+"%";
        el.style.display = t.save ? "" : "none";
      });
      $$("[data-price-per]").forEach(function(el){
        el.textContent = aud(t.per)+" per pair · "+t.pairs+" "+pairWord(t.pairs);
      });
      $$("[data-sticky-sub]").forEach(function(el){
        var packText = t.pairs+" "+pairWord(t.pairs);
      el.textContent = t.save ? packText+" · Save "+t.save+"%" : packText;
      });
      $$("[data-atc]").forEach(function(el){
        el.textContent = el.hasAttribute("data-atc-compact")
          ? "Add to cart"
          : "Add "+t.pairs+" "+pairWord(t.pairs)+" — "+aud(t.price);
      });
      renderColours();
      $$("[data-tier]").forEach(function(inp){
        inp.checked = (inp.getAttribute("data-tier") === state.tier);
      });
    }

    /* ---- delegated events ---- */
    if(window.__asBound) return;
    window.__asBound = true;

    document.addEventListener("change", function(e){
      if(e.target.matches && e.target.matches("[data-tier]")){ state.tier = e.target.value; render(); syncForm(); }
    });

    /* ---- cart ---- */
    var cart = [];
    function cartPairs(){ return cart.reduce(function(n,l){ return n + l.pairs * l.qty; }, 0); }
    function cartTotal(){ return cart.reduce(function(n,l){ return n + l.price * l.qty; }, 0); }
    function saveCart(){
      var badge = $("#cartCount");
      if(badge){
        var p = cart.reduce(function(n,l){ return n + l.qty; }, 0);
        badge.textContent = p;
        badge.style.display = p ? "block" : "none";
      }
    }
    function fromShopify(data){
      var meta = AS.variantMeta || {};
      cart = (data.items || []).map(function(it){
        var m = meta[it.id] || meta[String(it.id)] || {};
        var pairs = m.pairs || 1;
        return {key:it.key, id:it.id,
                label: m.name || it.product_title,
                pairs: pairs,
                price: it.final_price/100,
                colour: m.colour || it.variant_title || "",
                qty: it.quantity, line: it.key};
      });
      saveCart();
      renderCart();
    }
    function loadCart(){
      return fetch(AS.routes.cart + ".js", {headers:{"Accept":"application/json"}})
        .then(function(r){ return r.json(); }).then(fromShopify).catch(function(){});
    }
    function changeLine(key, qty){
      return fetch(AS.routes.cartChange + ".js", {
        method:"POST", headers:{"Content-Type":"application/json","Accept":"application/json"},
        body: JSON.stringify({id:key, quantity:qty})
      }).then(function(r){ return r.json(); }).then(fromShopify);
    }
    function addToCart(){
      var id = variantId();
      if(!id){ say("That combination is unavailable."); return Promise.resolve(); }
      return fetch(AS.routes.cartAdd + ".js", {
        method:"POST", headers:{"Content-Type":"application/json","Accept":"application/json"},
        body: JSON.stringify({items:[{id: id, quantity: 1}]})
      }).then(function(r){ return r.json(); }).then(function(res){
        if(res.status && res.status !== 200){ say(res.description || "Could not add to cart."); return; }
        return loadCart();
      }).catch(function(){ say("Could not add to cart. Please try again."); });
    }
    var drawer = $("#cartDrawer");
    function renderCart(){
      var box = $("#cartLines");
      if(!box) return;
      if(!cart.length){
        box.innerHTML = '<p class="as-cart__empty">Your cart is empty.</p>';
      }else{
        box.innerHTML = cart.map(function(l, i){
          return '<div class="as-cart__line">'
            + '<div><p class="as-cart__n">'+l.label+' — '+l.colour+'</p>'
            + '<p class="as-cart__m">'+l.pairs+' '+pairWord(l.pairs)+' · '+aud(l.price / l.pairs)+' per pair</p>'
            + '<div class="as-cart__qty">'
            + '<button class="as-cart__qb" data-qty="-1" data-i="'+i+'" aria-label="Decrease quantity">−</button>'
            + '<span class="as-cart__qn">'+l.qty+'</span>'
            + '<button class="as-cart__qb" data-qty="1" data-i="'+i+'" aria-label="Increase quantity">+</button>'
            + '<button class="as-cart__rm" data-rm="'+i+'">Remove</button>'
            + '</div></div>'
            + '<p class="as-cart__p">'+aud(l.price * l.qty)+'</p>'
            + '</div>';
        }).join("");
      }
      var tot = $("#cartTotal");
      if(tot) tot.textContent = aud(cartTotal());
    }
    function openCart(){
      renderCart();
      if(drawer) drawer.hidden = false;
      document.body.style.overflow = "hidden";
    }
    function closeCart(){
      if(drawer) drawer.hidden = true;
      document.body.style.overflow = "";
    }
    function showCart(){ openCart(); }
    function checkout(){
      if(!cart.length){ say("Your cart is empty."); return; }
      window.location.href = AS.routes.checkout;
    }
    loadCart();

    document.addEventListener("click", function(e){
      var t2 = e.target;
      if(!t2.closest) return;
      var soon = t2.closest("[data-soon]");
      if(soon){ e.preventDefault(); say("Coming soon…"); return; }
      var atc = t2.closest("[data-atc]");
      if(atc){ e.preventDefault(); addToCart().then(openCart); return; }
      if(t2.closest("[data-checkout-now]")){
        e.preventDefault();
        addToCart().then(function(){ window.location.href = AS.routes.checkout; });
        return;
      }
      if(t2.closest("[data-cart-close]")){ closeCart(); return; }
      if(t2.closest("[data-checkout]")){ checkout(); return; }
      var qb = t2.closest("[data-qty]");
      if(qb){
        var li = cart[+qb.getAttribute("data-i")];
        if(li){ changeLine(li.line, Math.max(0, li.qty + (+qb.getAttribute("data-qty")))); }
        return;
      }
      var rm = t2.closest("[data-rm]");
      if(rm){
        var line = cart[+rm.getAttribute("data-rm")];
        if(line){ changeLine(line.line, 0); }
        return;
      }
      var jump = t2.closest("[data-scroll-to]");
      if(jump){
        var target = document.querySelector(jump.getAttribute("data-scroll-to"));
        if(target){
          var top = target.getBoundingClientRect().top + window.pageYOffset;
          window.scrollTo({top: top, behavior:"smooth"});
        }
        return;
      }
      var cdot = t2.closest(".as-dot");
      if(cdot){
        syncForm();
        state.colour = cdot.getAttribute("data-colour");
        renderColours();
        return;
      }
      var fbnav = t2.closest("[data-fb-nav]");
      if(fbnav){
        var tr = $("#fbTrack");
        if(tr){
          var cards = Array.prototype.slice.call(tr.querySelectorAll(".as-fbp"));
          if(cards.length){
            var trRect = tr.getBoundingClientRect();
            var pad = parseFloat(getComputedStyle(tr).paddingLeft) || 0;
            var off = function(c){ return c.getBoundingClientRect().left - trRect.left - pad; };
            var cur = 0, best = Infinity;
            cards.forEach(function(c, i){
              var d = Math.abs(off(c));
              if(d < best){ best = d; cur = i; }
            });
            var next = Math.max(0, Math.min(cards.length - 1, cur + (+fbnav.getAttribute("data-fb-nav"))));
            var target = tr.scrollLeft + off(cards[next]);
            tr.scrollTo({left: Math.max(0, Math.min(tr.scrollWidth - tr.clientWidth, target)), behavior:"smooth"});
          }
        }
        return;
      }
      var chip = t2.closest(".as-chip");
      if(chip){ selectShoe(chip); return; }
      var gdot = t2.closest(".as-gal__dotbtn");
      if(gdot){ goSlide(+gdot.getAttribute("data-i")); return; }
      var thumb = t2.closest(".as-gal__thumb");
      if(thumb){ goSlide(+thumb.getAttribute("data-i")); return; }
      var hdr = t2.closest("[data-hdr]");
      if(hdr){
        if(hdr.getAttribute("data-hdr") === "cart"){ showCart(); }
        else{ say("Search connects once this is running in Shopify."); }
        return;
      }
    });

    /* ---- contact: plain email link in the footer ---- */
    var AS_CONTACT_EMAIL = AS.contactEmail || "";
    var cForm = $("#contactForm");
    if(cForm){
      cForm.addEventListener("submit", function(e){
        e.preventDefault();
        var d = new FormData(cForm);
        var name = (d.get("name")||"").toString().trim();
        var mail = (d.get("email")||"").toString().trim();
        var msg  = (d.get("message")||"").toString().trim();
        if(!msg){ say("Add a short message first."); return; }
        var body = msg + "\n\n—\n" + (name ? name : "(no name)") + (mail ? " · " + mail : "");
        window.location.href = "mailto:" + AS_CONTACT_EMAIL
          + "?subject=" + encodeURIComponent("Aussie Step enquiry" + (name ? " from " + name : ""))
          + "&body=" + encodeURIComponent(body);
        say("Opening your mail app…");
      });
    }

    /* ---- marquee ---- */
    var marqVp = $("#marqVp");
    if(marqVp){
      var marqSrc = marqVp.querySelector("[data-marq-set]").cloneNode(true);
      marqVp.innerHTML = "";
      marqVp.appendChild(marqSrc.cloneNode(true));
      marqVp.appendChild(marqSrc.cloneNode(true));
    }

    /* ---- hero gallery ---- */
    var track  = $("#galTrack");
    var dots   = $("#galDots");
    var thumbs = $("#galThumbs");
    var slides = track ? track.querySelectorAll(".as-gal__slide") : [];

    Array.prototype.forEach.call(slides, function(_, i){
      var d = document.createElement("button");
      d.className = "as-gal__dotbtn";
      d.setAttribute("data-i", i);
      d.setAttribute("aria-label", "Go to image "+(i+1));
      d.innerHTML = '<span class="as-gal__dot'+(i===0?" is-on":"")+'"></span>';
      dots.appendChild(d);

      var t = document.createElement("button");
      t.className = "as-gal__thumb"+(i===0?" is-on":"");
      t.setAttribute("data-i", i);
      t.setAttribute("aria-label", "Image "+(i+1));
      var src = slides[i].querySelector("img");
      if(src){ t.innerHTML = '<img src="'+src.getAttribute("src")+'" alt="" />'; }
      else { t.textContent = "0"+(i+1); }
      thumbs.appendChild(t);
    });

    function goSlide(i){
      track.scrollTo({left: i * (track.clientWidth + 10), behavior:"smooth"});
    }
    function syncGallery(){
      var i = Math.round(track.scrollLeft / (track.clientWidth + 10));
      i = Math.max(0, Math.min(slides.length-1, i));
      dots.querySelectorAll(".as-gal__dot").forEach(function(d,n){ d.classList.toggle("is-on", n===i); });
      thumbs.querySelectorAll(".as-gal__thumb").forEach(function(t,n){ t.classList.toggle("is-on", n===i); });
    }
    if(track){
      var galT;
      track.addEventListener("scroll", function(){
        clearTimeout(galT); galT = setTimeout(syncGallery, 60);
      }, {passive:true});
      track.addEventListener("keydown", function(e){
        var cur = Math.round(track.scrollLeft / (track.clientWidth + 10));
        if(e.key === "ArrowRight"){ e.preventDefault(); goSlide(Math.min(slides.length-1, cur+1)); }
        if(e.key === "ArrowLeft"){  e.preventDefault(); goSlide(Math.max(0, cur-1)); }
      });
    }

    /* ---- shoe selector ---- */
    var shoeTabs = $$("#shoeTabs .as-chip");
    var shoeCount = $("#shoeCount");
    function selectShoe(chip){
      var idx = shoeTabs.indexOf(chip);
      shoeTabs.forEach(function(t, i){
        var on = (i === idx);
        t.setAttribute("aria-selected", on ? "true" : "false");
        t.tabIndex = on ? 0 : -1;
        var panel = document.getElementById(t.getAttribute("aria-controls"));
        panel.classList.toggle("is-on", on);
        if(on){ panel.removeAttribute("hidden"); } else { panel.setAttribute("hidden",""); }
      });
      shoeCount.textContent = "0"+(idx+1)+" / 0"+shoeTabs.length;
      var rail = $("#shoeTabs");
      rail.scrollTo({left: Math.max(0, chip.offsetLeft - 20), behavior:"smooth"});
    }
    var rail = $("#shoeTabs");
    if(rail){
      rail.addEventListener("keydown", function(e){
        var i = shoeTabs.indexOf(document.activeElement);
        if(i < 0) return;
        var next = null;
        if(e.key === "ArrowRight") next = shoeTabs[(i+1) % shoeTabs.length];
        if(e.key === "ArrowLeft")  next = shoeTabs[(i-1+shoeTabs.length) % shoeTabs.length];
        if(e.key === "Home")       next = shoeTabs[0];
        if(e.key === "End")        next = shoeTabs[shoeTabs.length-1];
        if(next){ e.preventDefault(); next.focus(); selectShoe(next); }
      });
      if(shoeCount) shoeCount.textContent = "01 / 0"+shoeTabs.length;
    }

    /* ---- sale countdown ---- */
    /* resets every day at midnight Australian (Sydney) time */
    function auSecsLeft(){
      var parts, h = 0, m = 0, s = 0;
      try{
        parts = new Intl.DateTimeFormat("en-AU",{timeZone:"Australia/Sydney",hour12:false,
          hour:"2-digit",minute:"2-digit",second:"2-digit"}).formatToParts(new Date());
        parts.forEach(function(p){
          if(p.type === "hour") h = parseInt(p.value,10) % 24;
          if(p.type === "minute") m = parseInt(p.value,10);
          if(p.type === "second") s = parseInt(p.value,10);
        });
      }catch(e){
        var d = new Date(Date.now() + 10*3600*1000);
        h = d.getUTCHours(); m = d.getUTCMinutes(); s = d.getUTCSeconds();
      }
      return 86400 - (h*3600 + m*60 + s);
    }
    var saleBar = $("#saleBar");
    var clkD = $('[data-clk="d"]'), unitD = $('[data-unit="d"]'),
        clkH = $('[data-clk="h"]'), clkM = $('[data-clk="m"]'), clkS = $('[data-clk="s"]');
    function pad(n){ return n < 10 ? "0"+n : ""+n; }
    function tickSale(){
      if(!saleBar) return true;
      var t = auSecsLeft();
      unitD.hidden = true;
      clkH.textContent = pad(Math.floor(t%86400/3600));
      clkM.textContent = pad(Math.floor(t%3600/60));
      clkS.textContent = pad(t%60);
      return false;
    }
    if(!tickSale()) setInterval(tickSale, 1000);

    /* ---- sticky ATC + reveal ---- */
    var sticky = $("#stickyBar");
    var heroAtc = $("#heroAtc");
    if("IntersectionObserver" in window && sticky && heroAtc){
      new IntersectionObserver(function(entries){
        entries.forEach(function(en){
          sticky.classList.toggle("is-on", !en.isIntersecting && en.boundingClientRect.top < 0);
        });
      }, {threshold:0}).observe(heroAtc);

      var rvObs = new IntersectionObserver(function(entries, obs){
        entries.forEach(function(en){
          if(en.isIntersecting){ en.target.classList.add("is-in"); obs.unobserve(en.target); }
        });
      }, {threshold:0.08, rootMargin:"0px 0px -40px 0px"});
      $$(".as-rv").forEach(function(el){ rvObs.observe(el); });
    } else {
      $$(".as-rv").forEach(function(el){ el.classList.add("is-in"); });
    }

    render();
    syncForm();
  
  }
  if(document.readyState === "loading"){ document.addEventListener("DOMContentLoaded", init); }
  else { init(); }
})();
